import { type ComponentRef, Directive, inject, Input, type Type } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { type PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import { type PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { FormsListContextMenuComponent } from '../components/forms-list-context-menu/forms-list-context-menu.component';
import { FormsKpListStateService } from '../services/forms-kp-list-state.service';

@Directive({ selector: '[appFormsListContextMenu]', standalone: true })
export class FormsListContextMenuDirective extends ContextMenuDirective {
  @Input() public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';
  private readonly listState = inject(FormsKpListStateService);

  public registerInstance(component: ComponentRef<FormsListContextMenuComponent>): void {
    component.setInput('state', this.listState.state);
  }
  public registerComponent(): Type<FormsListContextMenuComponent> {
    return FormsListContextMenuComponent;
  }
}
